import { useParams } from "react-router-dom";
import { faCaretDown, faCaretUp, faClone, faFileCheck, faFileDownload, faFileUpload, faPen } from "@fortawesome/pro-solid-svg-icons";
import {
  faClock,
  faExclamationCircle,
  faDoNotEnter,
  faCheckCircle,
} from "@fortawesome/pro-duotone-svg-icons";
import { faDotCircle } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import countries from "@/resources/countries_label.json";
import { Modal } from "react-responsive-modal";
import { useContext, useState, useEffect } from 'react'
import * as Notification from "@/components/ui/Notification";
import IndividualService from "@/services/individual";
import { AuthContext } from "@/context/auth";
import SupportService from "@/services/support";
import UpdateValue from "@/components/sessions/UpdateValue";
import { Collapse } from 'react-collapse';

export default function IndividualIdentity(props) {
  const { app_id, session_id } = useParams();
  const [open, setOpen] = useState(false);
  const [auth] = useContext(AuthContext);
  const [manageable, setManageable] = useState(false);

  const [historyCollapse, setHistoryCollapse] = useState([]);
  const [documentHistory, setDocumentHistory] = useState([]);

  const [titleHistory, setTitleHistory] = useState(null);
  const [titleCollapse, setTitleCollapse] = useState(false);

  const [value, setValue] = useState("");
  const [title, setTitle] = useState("");

  const [aliasCopied, setAliasCopied] = useState(false);
  const [sessionCopied, setSessionCopied] = useState(false);

  async function ResetIndividualResource() {
    await IndividualService.ResetStep(session_id, props.step_id)
      .then(async (data) => {
        Notification.success("Onbaording updated");
      })
      .catch((err) => {
        Notification.error(err.message);
      });
  }

  useEffect(() => {
    let collapseHistory = []
    let newDocumentHistory = []
    let index = 0
    props.step.history.reverse().forEach(element => {
      if (index === 0) {
        if (props.step.history.length <= 1) {
          setTitleCollapse(true)
        }
        setTitleHistory(element)
      } else {
        newDocumentHistory.push(element)
        collapseHistory.push(false)
      }
      index = index + 1
    });
    setHistoryCollapse(collapseHistory)
    setDocumentHistory(newDocumentHistory)
    return () => { }
  }, [])

  useEffect(() => {
    setTimeout(() => { setAliasCopied(false) }, 10000);
    return () => { }
  }, [aliasCopied])

  useEffect(() => {
    setTimeout(() => { setSessionCopied(false) }, 10000);
    return () => { }
  }, [sessionCopied])

  function CollapseHistory(index) {
    let collapseHistory = []
    let i = 0
    historyCollapse.forEach(element => {
      if (i === index) {
        collapseHistory.push(!element)
      } else {
        collapseHistory.push(element)
      }
      i = i + 1
    });
    setHistoryCollapse(collapseHistory)
  }

  function IdentityTitle({ state }) {
    return (
      <div>
        <div className="flex justify-between items-center">
          <div>
            <p className="font-medium text-primary-400">
              {title ? title : "ID Document"}
            </p>
            {props.sub_session_id !== "" && props.sub_session_id !== undefined ? (
              <p className="font-medium text-gray-400">
                #{props.sub_session_id}
              </p>
            ) : null}
          </div>
          <div>
            <div className="flex">
              {props.reset !== 0 && props.reset !== undefined ? (
                <>
                  {props.reset === 1 ? (
                    <p className="text-orange-500 text-sm bg-orange-100 rounded-xl px-4 py-1 mr-4">
                      {props.reset} reset
                    </p>
                  ) :
                    <p className="text-red-500 text-sm bg-red-100 rounded-xl px-4 py-1 mr-4">
                      {props.reset} resets
                    </p>
                  }
                </>
              ) : null}
              {state === "PENDING" ? (
                <p className="text-orange-500 text-sm bg-orange-100 rounded-xl px-4 py-1">
                  <FontAwesomeIcon className="mr-0.5" icon={faClock} /> Pending
                  verification
                </p>
              ) : null}
              {state === "NOT_STARTED" ? (
                <>
                  {props.step.history.length === 0 ? (
                    <p className="text-gray-500 text-sm bg-gray-100 rounded-xl px-4 py-1">
                      <FontAwesomeIcon className="mr-0.5" icon={faDotCircle} />{" "}
                      Not started
                    </p>
                  ) : (
                    <p className="text-orange-500 text-sm bg-orange-100 rounded-xl px-4 py-1">
                      <FontAwesomeIcon
                        className="mr-0.5"
                        icon={faExclamationCircle}
                      />{" "}
                      Rejected
                    </p>
                  )}
                </>
              ) : null}
              {state === "FINAL_REJECTED" || state === "REJECTED" ? (
                <p className="text-red-500 text-sm bg-red-100 rounded-xl px-4 py-1">
                  <FontAwesomeIcon className="mr-0.5" icon={faDoNotEnter} /> Final
                  Rejected
                </p>
              ) : null}
              {state === "VALIDATED" ?
                <>
                  {props.did_issued === true ? <>
                    <p className="text-green-500 text-sm bg-green-100 rounded-xl px-4 py-1 mr-2">
                      <FontAwesomeIcon className="mr-0.5" icon={faCheckCircle} /> Anima issued
                    </p>
                  </> : null}
                  <p className="text-green-500 text-sm bg-green-100 rounded-xl px-4 py-1">
                    <FontAwesomeIcon className="mr-0.5" icon={faCheckCircle} /> Verified
                  </p></>
                : null}
            </div>
          </div>
        </div>
        {state !== "NOT_STARTED" ||
          (state === "NOT_STARTED" && props.step.history.length > 0) ? (
          <hr className="my-4 border-bluegray-200" />
        ) : null}
      </div>
    );
  }

  function IdentityFooter({ state }) {
    return (
      <div>
        <hr className="my-4 border-bluegray-200" />
        <div className="flex justify-between items-center">
          <div>
            {props.step.history.length > 0 ? (
              <p
                onClick={() => setOpen(true)}
                className="text-blue-500  cursor-pointer text-sm px-5 p-3 mr-3"
              >
                Show History
              </p>
            ) : null}
          </div>
          <div>
            <div className="flex">
              {state === "NOT_STARTED" &&
                props.source !== "CORPORATE" &&
                props.step.history.length > 0 &&
                (auth.iam.admin === true || auth.iam.support_manager === true) ? (
                <p
                  onClick={() => ResetTaskIndividualResource()}
                  className="text-black hover:bg-gray-100 ease-in duration-200 transition cursor-pointer text-sm border border-gray-200 rounded-md px-5 p-3 mr-3"
                >
                  Back to task
                </p>
              ) : null}
              {state !== "VALIDATED" && state !== "NOT_STARTED" && props.reset !== 2 &&
                props.source !== "CORPORATE" &&
                (auth.iam.admin === true || auth.iam.support_manager === true || auth.iam.support_agent === true) ? (
                <p
                  onClick={() => ResetIndividualResource()}
                  className="text-white cursor-pointer text-sm bg-primary-500 rounded-md px-5 p-3 mr-3"
                >
                  Reset
                </p>
              ) :
                <p
                  className="text-gray-400 text-sm bg-gray-100 cursor-not-allowed rounded-md px-5 p-3 mr-3"
                >
                  Reset
                </p>}
            </div>
          </div>
        </div>
      </div>
    );
  }

  function HistoryTitle() {
    return (
      <div className="history-title">
        <div className="flex justify-between items-center pb-2 px-6 pt-6">
          <div>
            <p className="font-medium text-primary-400">
              ID Document
            </p>
          </div>
          <div>
            <div className="flex">
              {props.step.state === "PENDING" ? (
                <p className="text-orange-500 text-sm bg-orange-100 rounded-xl px-4 py-1">
                  <FontAwesomeIcon className="mr-0.5" icon={faClock} /> Pending
                  verification
                </p>
              ) : null}
              {props.step.state === "NOT_STARTED" ? (
                <>
                  {props.step.history.length === 0 ? (
                    <p className="text-gray-500 text-sm bg-gray-100 rounded-xl px-4 py-1">
                      <FontAwesomeIcon className="mr-0.5" icon={faDotCircle} />{" "}
                      Not started
                    </p>
                  ) : (
                    <p className="text-orange-500 text-sm bg-orange-100 rounded-xl px-4 py-1">
                      <FontAwesomeIcon
                        className="mr-0.5"
                        icon={faExclamationCircle}
                      />{" "}
                      Rejected
                    </p>
                  )}
                </>
              ) : null}
              {props.step.state === "FINAL_REJECTED" || props.step.state === "REJECTED" ? (
                <p className="text-red-500 text-sm bg-red-100 rounded-xl px-4 py-1">
                  <FontAwesomeIcon className="mr-0.5" icon={faDoNotEnter} /> Final
                  Rejected
                </p>
              ) : null}
              {props.step.state === "VALIDATED" ? (
                <p className="text-green-500 text-sm bg-green-100 rounded-xl px-4 py-1">
                  <FontAwesomeIcon className="mr-0.5" icon={faCheckCircle} /> Verified
                </p>
              ) : null}
            </div>
          </div>
        </div>
        {props.step.history.length > 0 ?
          <>
            <div onClick={() => setTitleCollapse(!titleCollapse)} className="mt-4 px-5 pb-2 flex justify-between cursor-pointer">
              <div>
                {titleHistory.state !== "VALIDATED" ?
                  <div className="flex border border-transparent py-1 px-1.5 rounded-xl">
                    <div className="top-[2px]">
                      <p className="text-sm font-bold mb-2">CUSTOMER REASON</p>
                      <p className='text-sm'>
                        {titleHistory.customer_reason}
                      </p>
                    </div>
                  </div> : null}
              </div>
              {titleCollapse ? (
                <div><FontAwesomeIcon className="mr-1" icon={faCaretUp} /></div>
              ) : (<div><FontAwesomeIcon className="mr-1" icon={faCaretDown} /></div>)}
            </div>
            <Collapse isOpened={titleCollapse}>
              <div className="px-4">
                <div className="flex px-2">
                  <div className="bg-bluegray-100 p-2 rounded-full"><div className="m-2"><FontAwesomeIcon className="text-regular mx-2 mt-1 mb-1 font-bold text-xl text-gray-500" icon={faFileDownload} /></div></div>
                  <div className="mt-3 ml-4">
                    <p className="text-sm font-bold mb-2">SUBMITED AT</p>
                    <p className='text-sm'>
                      {titleHistory.submitted_at}
                    </p>
                  </div>
                </div>
              </div>
              <div className="ml-8">
                <div className="vl pl-4"></div>
              </div>
              <div className="px-4 mb-3">
                <div className="flex px-2">
                  <div className="bg-bluegray-100 p-2 rounded-full"><div className="m-2"><FontAwesomeIcon className="text-regular mx-2 mt-1 mb-1 font-bold text-xl text-gray-500" icon={faFileCheck} /></div></div>
                  <div className="mt-3 ml-4">
                    <p className="text-sm font-bold mb-2">VERIFIED AT</p>
                    <p className='text-sm'>
                      {titleHistory.verified_at}
                    </p>
                  </div>
                </div>
              </div>
            </Collapse>
            <hr className="border-bluegray-200" />
          </>
          : null}
      </div >
    );
  }

  function HistoryElement({ element, index }) {
    return (
      <div className="history-title">
        <div onClick={() => CollapseHistory(index)} className="mt-4 px-5 flex justify-between cursor-pointer">
          <div>
            {element.state === "REJECTED" ?
              <div className="">
                <div className="flex px-1">
                  <div>
                    <div className="bg-orange-100 p-2 rounded-full"><div className="m-2"><FontAwesomeIcon className="text-regular mx-2 mt-1 mb-1 font-bold text-xl text-orange-500" icon={faFileUpload} /></div></div>
                  </div>
                  <div className="ml-4">
                    <p className="text-sm font-bold mb-1">RESUBMISSION REQUEST</p>
                    <p className='text-sm'>
                      {element.customer_reason}
                    </p>
                  </div>
                </div>
              </div> : null}
            {element.state === "FINALE_REJECTED" ?
              <div className="mb-3">
                <div className="flex px-1">
                  <div>
                    <div className="bg-red-100 p-2 rounded-full"><div className="m-2"><FontAwesomeIcon className="text-regular mx-2 mt-1 mb-1 font-bold text-xl text-red-500" icon={faDoNotEnter} /></div></div>
                  </div>
                  <div className="mt-3 ml-4">
                    <p className="text-sm font-bold mb-1">FINAL REJECTED</p>
                    <p className='text-sm'>
                      {element.customer_reason}
                    </p>
                  </div>
                </div>
              </div> : null}
            {element.state === "VALIDATED" ?
              <div className="">
                <div className="flex px-1">
                  <div>
                    <div className="bg-green-100 p-2 rounded-full"><div className="m-2"><FontAwesomeIcon className="text-regular mx-2 mt-1 mb-1 font-bold text-xl text-green-500" icon={faFileCheck} /></div></div>
                  </div>
                  <div className="ml-4">
                    <p className="text-sm font-bold mb-1">VALIDATED</p>
                    <p className='text-sm'>
                      {element.customer_reason}
                    </p>
                  </div>
                </div>
              </div> : null}
          </div>
          {historyCollapse[index] ? (
            <div><FontAwesomeIcon className="mr-1" icon={faCaretUp} /></div>) : <div><FontAwesomeIcon className="mr-1" icon={faCaretDown} /></div>}
        </div>
        {historyCollapse[index] ? (
          <div className="ml-8">
            <div className="vl pl-4"></div>
          </div>
        ) :
          <div className="mb-4"></div>}
        <Collapse isOpened={historyCollapse[index]}>
          <div className="px-4">
            <div className="flex px-2">
              <div className="bg-bluegray-100 p-2 rounded-full"><div className="m-2"><FontAwesomeIcon className="text-regular mx-2 mt-1 mb-1 font-bold text-xl text-gray-500" icon={faFileDownload} /></div></div>
              <div className="mt-2 ml-4">
                <p className="text-sm font-bold mb-2">SUBMITED AT</p>
                <p className='text-sm'>
                  {element.submitted_at}
                </p>
              </div>
            </div>
          </div>
          <div className="ml-8">
            <div className="vl pl-4"></div>
          </div>
          <div className="px-4 mb-3">
            <div className="flex px-2">
              <div className="bg-bluegray-100 p-2 rounded-full"><div className="m-2"><FontAwesomeIcon className="text-regular mx-2 mt-1 mb-1 font-bold text-xl text-gray-500" icon={faFileCheck} /></div></div>
              <div className="mt-2 ml-4">
                <p className="text-sm font-bold mb-2">VERIFIED AT</p>
                <p className='text-sm'>
                  {element.verified_at}
                </p>
              </div>
            </div>
          </div>
        </Collapse>
      </div >
    );
  }

  function HistoryFooter({ duplicate }) {
    return (
      <div className="bg-bluegray-100">
        {duplicate.session_id !== '' && duplicate.session_id !== undefined ?
          <div className="px-6 pt-3 pb-6">
            {duplicate.alias !== undefined ? <div className="mt-2 mb-6">
              <div className="flex border border-transparent py-1 px-1.5 rounded-xl">
                <div className="relative top-[2px]">
                  <p className="text-sm font-bold mb-2">VALIDATED CUSTOMER ALIAS</p>
                  <div className="flex mb-1">
                    <p className='text-sm mt-1'>
                      {duplicate.alias}
                    </p>
                    <FontAwesomeIcon className="text-regular mx-2 mt-1 mb-1 font-bold cursor-pointer text-md text-blue-500" onClick={() => navigator.clipboard.writeText(duplicate.alias) & setAliasCopied(true)} icon={faClone} />
                    {aliasCopied ? <p className='text-sm mt-1 text-green-500'>
                      Text copied!
                    </p> : null}
                  </div>
                </div>
              </div>
            </div> : null}
            <div className="mt-6">
              <div className="flex border border-transparent py-1 px-1.5 rounded-xl">
                <div className="relative top-[2px]">
                  <p className="text-sm font-bold mb-2">VALIDATED SESSION ID</p>
                  <div className="flex mb-1">
                    <p className='text-sm mt-1'>
                      {duplicate.session_id}
                    </p>
                    <FontAwesomeIcon className="text-regular mx-2 mt-1 mb-1 font-bold cursor-pointer text-md text-blue-500" onClick={() => navigator.clipboard.writeText(duplicate.session_id) & setSessionCopied(true)} icon={faClone} />
                    {sessionCopied ? <p className='text-sm mt-1 text-green-500'>
                      Text copied!
                    </p> : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          : null}
      </div>
    );
  }

  function EditInfo(title, value) {
    setValue(value);
    setTitle(title);
    setManageable(true);
  }

  async function ResetTaskIndividualResource() {
    await IndividualService.ResetTaskStep(session_id, props.step_id)
      .then(async (data) => {
        Notification.success("Onbaording updated");
      })
      .catch((err) => {
        Notification.error(err.message);
      });
  }

  async function UpdateIndividualValue(value) {
    let body = {
      value: value,
      type: title.toUpperCase(),
      session_id: session_id,
      step_id: props.step_id,
    };
    await SupportService.UpdateValue(body)
      .then(async (data) => {
        Notification.success("Value updated");
        props.onRefresh();
        setManageable(false);
      })
      .catch((err) => {
        Notification.error(err.message);
        setManageable(false);
      });
  }

  function InfoItem(props) {
    return (
      <div className="mt-2">
        <div className="flex border border-transparent py-1 px-1.5 rounded-xl">
          <div className="mr-3 mt-0.5 flex-shrink-0">
            <img className="h-9" src={`/img/icons/ui/${props.icon}.svg`}></img>
          </div>
          <div className="relative top-[2px]">
            <p className="text-bluegray-400 text-xs">{props.title}</p>
            <p
              className={`text-gray-600 text-sm ${props.capitalize ? "capitalize" : null
                }`}
            >
              {props.value}
            </p>
          </div>
          <div className="group">
            {props.source !== "CORPORATE" &&
              (auth.iam.admin === true || auth.iam.support_manager === true) ? (
              <FontAwesomeIcon
                onClick={() => EditInfo(props.title, props.value)}
                className="mt-3 ml-4 text-regular font-bold text-sm text-gray-500 cursor-pointer group-hover:text-red-500  transition duration-100 ease-in ml-2"
                icon={faPen}
              ></FontAwesomeIcon>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  function InfoHistoryItem(props) {
    return (
      <div className="mt-2">
        <div className="flex border border-transparent py-1 px-1.5 rounded-xl">
          <div className="mr-3 mt-0.5 flex-shrink-0">
            <img className="h-9" src={`/img/icons/ui/${props.icon}.svg`}></img>
          </div>
          <div className="relative top-[2px]">
            <p className="text-bluegray-400 text-xs">{props.title}</p>
            <p
              className={`text-gray-600 text-sm ${props.capitalize ? "capitalize" : null
                }`}
            >
              {props.value}
            </p>
          </div>
        </div>
      </div>
    );
  }

  function CountryItem(props) {
    return (
      <div className="mt-2">
        <div className="flex border border-transparent py-1 px-1.5 rounded-xl">
          <div className="mr-3 flex-shrink-0">
            <div
              className="h-9 w-9"
              style={{
                backgroundImage: `url( ${`/img/icons/flags-rounded/${props.country}.svg`}), url(${"/img/icons/ui/icon-round.svg"})`,
                backgroundSize: "60%, contain",
                backgroundRepeat: "no-repeat, no-repeat",
                backgroundPosition: "center center, center center",
              }}
            ></div>
          </div>
          <div className="relative top-[2px]">
            <p className="text-bluegray-400 text-xs">{props.title}</p>
            <p className="text-gray-600 text-sm">{props.value}</p>
          </div>
        </div>
      </div>
    );
  }

  function InfoFeature(props) {
    return (
      <div className="mt-2">
        <div className="flex border border-transparent py-1 px-1.5 rounded-xl">
          <div className="mr-3 mt-0.5 flex-shrink-0">
            <img className="h-9" src={`/img/icons/ui/${props.icon}.svg`}></img>
          </div>
          <div className="relative top-[2px]">
            <p className="text-bluegray-400 text-xs capitalize">
              {props.title}
            </p>
            {props.included ? (
              <p className="text-green-500 text-sm">{props.label}</p>
            ) : (
              <p className="text-red-500 text-sm">Not {props.label}</p>
            )}
          </div>
        </div>
      </div>
    );
  }

  function IdentityDocument({ step_id, document, info }) {
    return (
      <div>
        <div className="mt-3">
          <p className="mt-6 uppercase tracking-wide font-medium text-sm text-primary-400">
            Document Details
          </p>
          <div className="flex flex-wrap mt-3">
            <div className="w-1/5 pr-3">
              {session_id !== undefined ? (
                <div
                  className="bg-bluegray-100 w-full h-[200px] px-2 rounded-md mt-3"
                  style={{
                    backgroundImage: `url()`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                  }}
                ></div>
              ) : null}
            </div>
            <div className="w-4/5 pl-3 flex flex-wrap mt-4">
              <div className="w-1/3">
                <InfoItem
                  capitalize
                  icon={"icon-firstname"}
                  source={props.source}
                  title="Firstname"
                  value={
                    info.firstname.value
                      ? info.firstname.value.toLowerCase()
                      : "-"
                  }
                />
              </div>
              <div className="w-1/3">
                <InfoItem
                  capitalize
                  icon={"icon-lastname"}
                  source={props.source}
                  title="Lastname"
                  value={
                    info.lastname.value
                      ? info.lastname.value.toLowerCase()
                      : "-"
                  }
                />
              </div>
              <div className="w-1/3">
                <InfoItem
                  icon={"icon-birthdate"}
                  source={props.source}
                  title="Birth Date"
                  value={info.birth_date.value ? info.birth_date.value : "-"}
                />
              </div>
              <div className="w-1/3">
                <CountryItem
                  title="Nationality"
                  source={props.source}
                  value={
                    info.nationality.value
                      ? countries[info.nationality.value]
                      : "-"
                  }
                  country={info.nationality.value}
                />
              </div>
              <div className="w-1/3">
                <CountryItem
                  title="Issuing Country"
                  source={props.source}
                  value={countries[document.document.country]}
                  country={document.document.country}
                />
              </div>
              <div className="w-1/3">
                <InfoItem
                  title="Document Number"
                  source={props.source}
                  icon={"icon-document-number"}
                  value={
                    info.document_number.value
                      ? info.document_number.value
                      : "-"
                  }
                />
              </div>
              <div className="w-1/3">
                <InfoItem
                  title="Document Expiration"
                  source={props.source}
                  value={
                    info.document_expiration.value
                      ? info.document_expiration.value
                      : "-"
                  }
                  icon={"icon-recent"}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <div className="flex flex-wrap">
            <div
              className={`${document.document.type === "PASSPORT" ? "w-full" : "w-1/2 pr-3"
                }`}
            >
              <p className="uppercase tracking-wide font-medium text-sm text-primary-400">
                {document.document.type === "PASSPORT"
                  ? "Passport page"
                  : "Front Document"}
              </p>
              <div className="bg-bluegray-100 w-full h-96 px-2 rounded-md mt-3">
                <img
                  src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                  className="w-full h-96"
                  style={{
                    backgroundImage: `url('${document.document.front_file}')`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                  }}
                />
              </div>
            </div>
            {document.document.type !== "PASSPORT" ? (
              <div className="w-1/2 pl-3">
                <p className="uppercase tracking-wide font-medium text-sm text-primary-400">
                  Back Document
                </p>
                <div className="bg-bluegray-100 w-full h-96 px-2 rounded-md mt-3">
                  <img
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    className="w-full h-96"
                    style={{
                      backgroundImage: `url('${document.document.back_file}')`,
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center center",
                    }}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  function IdentityVisualChecks({ visual }) {
    return (
      <div>
        <div className="mt-3">
          <p className="mt-6 uppercase tracking-wide font-medium text-sm text-primary-400">
            Visual Checks
          </p>
          <div className="flex flex-wrap">
            <div className="w-1/3 mt-2">
              <InfoFeature
                title="Colored picture"
                icon={`${visual.color_picture ? "icon-valid" : "icon-rejected"
                  }`}
                included={visual.color_picture}
                label="Verified"
              />
            </div>
            <div className="w-1/3 mt-2">
              <InfoFeature
                title="4 corners visible"
                icon={`${visual.full_document_visible ? "icon-valid" : "icon-rejected"
                  }`}
                included={visual.full_document_visible}
                label="Verified"
              />
            </div>
            <div className="w-1/3 mt-2">
              <InfoFeature
                title="Good environment capture"
                icon={`${visual.good_environment ? "icon-valid" : "icon-rejected"
                  }`}
                included={visual.good_environment}
                label="Verified"
              />
            </div>
            <div className="w-1/3 mt-2">
              <InfoFeature
                title="Good quality document"
                icon={`${visual.good_quality ? "icon-valid" : "icon-rejected"}`}
                included={visual.good_quality}
                label="Verified"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  function IdentityFeaturesChecks({ title, features }) {
    return (
      <div>
        <div className="mt-3">
          <p className="mt-6 uppercase tracking-wide font-medium text-sm text-primary-400">
            {title}
          </p>
          <div className="flex flex-wrap">
            {features.map((feature) => {
              return (
                <>
                  <div className="w-1/3 mt-2">
                    <InfoFeature
                      title={feature.name}
                      icon={`${feature.included ? "icon-valid" : "icon-rejected"
                        }`}
                      included={feature.included}
                      label="Included"
                    />
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  function IdentityMrzChecks({ title, mrz, type }) {
    return (
      <div>
        <div className="mt-3">
          <p className="mt-6 uppercase tracking-wide font-medium text-sm text-primary-400">
            {title}
          </p>
          <div className="flex flex-wrap">
            <div className="w-1/3 mt-2">
              <InfoFeature
                icon={`${type === "mrz" ? "icon-mrz" : "icon-barcode"}`}
                title={"Feature"}
                included={mrz.valid}
                label="Included"
              />
            </div>
            <div className="w-1/3 mt-2">
              <InfoFeature
                icon={`${mrz.valid ? "icon-valid" : "icon-rejected"}`}
                title={"Checksum"}
                included={mrz.valid}
                label="Valid"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  function IdentityDetails() {
    return (
      <div>
        <IdentityDocument
          member_id={props.member_id}
          step_id={props.step_id}
          document={props.step.document}
          info={props.step.document.details.info}
        />
        <IdentityVisualChecks
          document={props.step.document}
          visual={props.step.document.visual_checks}
        />
        <IdentityFeaturesChecks
          title={"Fields Checks"}
          document={props.step.document}
          features={props.step.document.details.features.fields}
        />
        <IdentityFeaturesChecks
          title={"Security Features Checks"}
          document={props.step.document}
          features={props.step.document.details.features.security}
        />
        {props.step.document.details.mrz.lines !== undefined &&
          props.step.document.details.mrz.lines.required ? (
          <IdentityMrzChecks
            type="mrz"
            title={"Machine Readable Zone (MRZ)"}
            mrz={props.step.document.details.mrz.lines}
          />
        ) : null}
        {props.step.document.details.mrz.barcode !== undefined &&
          props.step.document.details.mrz.barcode.required ? (
          <IdentityMrzChecks
            type="barcode"
            title={"Barcode"}
            mrz={props.step.document.details.mrz.barcode}
          />
        ) : null}
      </div>
    );
  }

  function IdentityBaseDetails() {
    return (
      <div>
        {props.step.state === "REJECTED" ? (
          <div className="flex flex-wrap">
            <div className="w-1/2">
              <InfoItem
                icon={"icon-firstname"}
                title="Customer Reason"
                value={props.step.document.rejection.customer_reason}
              />
            </div>
          </div>
        ) : null}
        <div className="mt-5">
          <div className="flex flex-wrap">
            <div
              className={`${props.step.document.document.type === "PASSPORT"
                ? "w-full"
                : "w-1/2 pr-3"
                }`}
            >
              <p className="uppercase tracking-wide font-medium text-sm text-primary-400">
                {props.step.document.document.type === "PASSPORT"
                  ? "Passport page"
                  : "Front Document"}
              </p>
              <div className="bg-bluegray-100 w-full h-96 px-2 rounded-md mt-3">
                <img
                  src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                  className="w-full h-96"
                  style={{
                    backgroundImage: `url('${props.step.document.document.front_file}')`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                  }}
                />
              </div>
            </div>
            {props.step.document.document.type !== "PASSPORT" ? (
              <div className="w-1/2 pl-3">
                <p className="uppercase tracking-wide font-medium text-sm text-primary-400">
                  Back Document
                </p>
                <div className="bg-bluegray-100 w-full h-96 px-2 rounded-md mt-3">
                  <img
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    className="w-full h-96"
                    style={{
                      backgroundImage: `url('${props.step.document.document.back_file}')`,
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center center",
                    }}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <IdentityTitle title={props.title} state={props.step.state} />
      {props.step.state === "VALIDATED" ? (
        <IdentityDetails
          member_id={props.member_id}
          step_id={props.step_id}
          step={props.step}
        />
      ) : null}
      {props.step.state === "PENDING" ||
        props.step.state === "REJECTED" ||
        (props.step.state === "NOT_STARTED" && props.step.history.length > 0) ? (
        <IdentityBaseDetails
          member_id={props.member_id}
          step_id={props.step_id}
          step={props.step}
        />
      ) : null}
      <IdentityFooter title={props.title} state={props.step.state} />
      <Modal
        open={open}
        showCloseIcon={true}
        closeIcon={true}
        onClose={() => setOpen(false)}
        center
      >
        <div className="core-view-history history-view">
          <HistoryTitle />
          {documentHistory.length > 0 ?
            <div className="px-1 mt-4">
              <p className="px-6 font-medium text-primary-400">
                HISTORY
              </p>
            </div>
            : null}
          {documentHistory.map((history, index) => {
            return (
              <HistoryElement key={index} element={history} index={index}></HistoryElement>
            );
          })}
          <HistoryFooter duplicate={props.step.duplicate} />
        </div>
      </Modal>

      <UpdateValue
        open={manageable}
        onClose={() => setManageable(false)}
        onUpdate={(value) => UpdateIndividualValue(value)}
        value={title}
        old={value}
      ></UpdateValue>
    </div>
  );
}
